export const whitespace = /[ \t\r\n]/;

export const dimensions = /^(?:offset|client)(?:Width|Height)$/;
